module.exports = __webpack_public_path__ + "static/img/19.1c02558.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/19.png
// module id = yBIx
// module chunks = 0